function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { node, string } from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import SovosToolbarGroup from '../sovos-toolbar-group';
const StyledToolbarGroup = styled(SovosToolbarGroup)({
  marginInlineStart: 'auto',
  // should this be in toolbar search?
  '& .sovosToolbarSearch--expanded': {
    marginInlineStart: -1
  }
});

/**
 * `SovosToolbarActions` component wraps, and properly positions child
 * components: `SovosToolbarSearch`, `SovosToolbarColumn`,
 * `SovosToolbarMoreMenu` or `SovosToolbarFilter`. **Note**: must be a
 * child of the `SovosToolbar` component
 */
const SovosToolbarActions = _ref => {
  let {
    children,
    className,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledToolbarGroup, _extends({}, props, {
    className: clsx('sovosToolbarActions', className)
  }), children);
};
SovosToolbarActions.propTypes = {
  /**
   * The content of the toolbar actions. Should be a collection of
   * `SovosToolbarFilter`, `SovosToolbarColumn`, `SovosToolbarSearch`,
   * `SovosIconMenu`, and `SovosIconButton`
   */
  children: node.isRequired,
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
export default SovosToolbarActions;